import { apiClient } from './config';

/**
 * Fetch all demo requests
 */
export const fetchDemoRequests = async () => {
  const response = await apiClient.get('/request_demo');
  return response.data;
};

/**
 * Delete a demo request
 */
export const deleteDemoRequest = async (id) => {
  const response = await apiClient.delete(`/request_demo/${id}`);
  return response.data;
};
